import AnnotationTableControls from "./components/AnnotationTableControls";
import annotationTableControlsReducer from "./store/AnnotationTableControlsSlice";

export { annotationTableControlsReducer };
export default AnnotationTableControls;
